import {graphql, useStaticQuery} from 'gatsby';
import type {SiteMetadata} from '../../gatsby-config';

type SiteQuery = {
  site: {
    siteMetadata: SiteMetadata;
  };
};

/**
 * Get siteMetadata from gatsby-config
 * @return {SiteMetadata}
 */
export const useSiteMetadata = (): SiteMetadata => {
  const data = useStaticQuery<SiteQuery>(graphql`
    query {
      site {
        siteMetadata {
          authorName
          description
          downloadUrl
          downloadUrlAppStoreParam
          downloadUrlGooglePlayParam
          downloadUrlHelloVandle
          facebookAppId
          facebookPage
          googleSiteVerification
          lineAt
          ogImage
          siteCopy
          siteName
          siteTitle
          siteUrl
          twitter
          twitterUsername
          vandleWebURL
        }
      }
    }
  `);
  return {...data.site.siteMetadata};
};
